import Vue from 'vue'
import Vuex from 'vuex'

import permission from './modules/permission'

import talent from './modules/talent'
import logs from './modules/logs'
import employee from './modules/employee'
import login from './modules/login'
import attend from './modules/attend'
import user from './modules/user'
import announcement from './modules/announcement'
import teamwork from './modules/teamwork'
import tandeAudit from './modules/tandeAudit'
import project from './modules/project'
import customer from './modules/customer'
import approval from './modules/approval'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    permission,
    talent,
    logs,
    employee,
    login,
    attend,
    user,
    announcement,
    teamwork,
    tandeAudit,
    project,
    customer,
    approval
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js